/**
 * SourceBadge — SSO vs. Manual provisioning indicator for a platform user.
 * Extracted from `routes/admin/users/index.tsx` (issue #1411).
 */
export function SourceBadge({ source }: { source: 'sso' | 'manual' }): JSX.Element {
  return (
    <span
      className={`users-source-badge users-source-badge--${source}`}
      data-testid={`source-badge-${source}`}
    >
      {source === 'sso' ? 'SSO' : 'Manual'}
    </span>
  );
}
